import { INiche } from "@/common/services/types";
import { Image } from "@/components/UI/Image";

import "./NicheSelector.scss";
import { useCallback } from "react";
import { updateSelectedNiches } from "./utils";
import { Checkbox } from "@/components/inputs/Checkbox";
import { useSfw } from "@/common/hooks/useSfw";

interface IProps {
  niches: INiche[];
  selected: string[];
  onChange: (values: string[]) => void;
}

export const NicheSelector = ({ niches, selected, onChange }: IProps) => {
  const { sanitizeNiche, isLoading } = useSfw();

  const handleCheckBoxChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(updateSelectedNiches(event.target.name, selected));
  }, [onChange, selected]);

  if (isLoading) {
    return null;
  }

  if (niches.length === 0) {
    return <div className="nicheSelector">This GIF has not been added to any niche.</div>;
  }

  return (
    <div className="nicheSelector">
      {niches.map((el: INiche) => {
        const niche = sanitizeNiche(el);

        return (
          <div className="row" key={niche.id}>
            <Image className={"thumbnail"} src={niche.thumbnail}/>

            <div className="name">{niche.name}</div>

            <Checkbox
              name={niche.id}
              onChange={handleCheckBoxChange}
              checked={selected.indexOf(niche.id) >= 0}
            />
          </div>
        );
      })}
    </div>
  );
};
